import { type CSSProperties, type FC, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface NavPillProps {
	ariaLabel: string
	children: ReactNode
	className?: string
	style?: CSSProperties
}

export const NavPill: FC<NavPillProps> = ({
	ariaLabel,
	children,
	className,
	style,
}) => (
	<nav
		aria-label={ariaLabel}
		style={style}
		className={cn(
			'pointer-events-auto relative isolate mx-auto flex h-[72px] w-fit max-w-[calc(100%_-_28px)] items-center justify-center gap-2 overflow-hidden rounded-[29px] bg-[#FBFBFA]/[0.82] p-[7px] shadow-[0_14px_30px_rgba(17,19,22,0.065),0_1px_4px_rgba(17,19,22,0.04),inset_0_0_0_1px_rgba(22,24,28,0.052),inset_0_1px_0_rgba(255,255,255,0.76)] backdrop-blur-[18px] backdrop-saturate-[1.12]',
			className,
		)}
	>
		<span
			aria-hidden="true"
			className="pointer-events-none absolute inset-x-9 top-px h-px bg-white/60"
		/>
		{children}
	</nav>
)
